import React from 'react';
import { Link } from 'react-router-dom';
import { getBrand } from '../utils/brandStyles';

/**
 * Full-width CTA banner — bottom of every page.
 *
 * Props:
 *   market      – 'mwo' | 'bg' | 'lu'
 *   title       – heading
 *   body        – supporting text
 *   ctaText     – button label
 *   ctaLink     – path or URL
 *   ctaExternal – true if external URL
 */
const CTABanner = ({ market, title, body, ctaText, ctaLink, ctaExternal }) => {
  const b = getBrand(market);

  const Btn = ctaExternal
    ? <a href={ctaLink} target="_blank" rel="noopener noreferrer" className={b.ctaBtnClass}>{ctaText}</a>
    : <Link to={ctaLink} className={b.ctaBtnClass}>{ctaText}</Link>;

  if (b.isMWO) {
    return (
      <section style={{
        background: '#111318',
        padding: 'clamp(60px, 8vw, 96px) clamp(24px, 6vw, 80px)',
        borderTop: '1px solid rgba(255,255,255,0.07)'
      }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <div style={{ width: '40px', height: '3px', background: '#00BCD4', marginBottom: '28px' }} />
          <h2 style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 800,
            fontSize: 'clamp(1.8rem, 4vw, 3rem)',
            color: '#E8E4DC',
            letterSpacing: '-0.02em',
            marginBottom: '16px',
            lineHeight: 1.1
          }}>{title}</h2>
          {body && (
            <p style={{
              fontFamily: b.fontBody,
              fontSize: b.fz.lg,
              lineHeight: 1.75,
              color: 'rgba(232,228,220,0.74)',
              marginBottom: '36px',
              maxWidth: '540px'
            }}>{body}</p>
          )}
          {Btn}
        </div>
      </section>
    );
  }

  /* ── Mind IT CTA ── */
  return (
    <section style={{
      background: '#0F1B45',
      padding: 'clamp(60px, 8vw, 96px) clamp(24px, 6vw, 80px)',
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h2 style={{
          fontFamily: "'Libre Baskerville', Georgia, serif",
          fontWeight: 700,
          fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)',
          color: '#ffffff',
          marginBottom: '16px',
          lineHeight: 1.25
        }}>{title}</h2>
        {body && (
          <p style={{
            fontSize: 'clamp(0.95rem, 2vw, 1.1rem)',
            lineHeight: 1.75,
            color: 'rgba(255,255,255,0.75)',
            marginBottom: '36px',
            maxWidth: '600px',
            margin: '0 auto 36px'
          }}>{body}</p>
        )}
        {Btn}
      </div>
    </section>
  );
};

export default CTABanner;
